const url = "https://lw-monitoring-backend.herokuapp.com";
// const url = "http://localhost:35000";

export const backend = {
  url,
  api: `${url}/api/v2`,
  latestClientUrl: `${url}/client/latest`,
};
